import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, DatePicker, Button, Card, Col, Row, Modal } from "antd";
import { useCurrencyConverter } from '../../context/currencyHook';
import { useCurrency } from '../../context/CurrencyContext';
import config from '../../config';

const { RangePicker } = DatePicker;

const TourPackageSelectForm = forwardRef(({ initialValues, vehicles, loading, setSelectedVehicle, selectedVehicle, setSelectedVehicleReturn, selectedVehicleReturn, isReturn }, ref) => {

    const convertCurrency = useCurrencyConverter();
    const { currency } = useCurrency();

    const [form] = Form.useForm();

    useImperativeHandle(ref, () => ({
        submit: () => {
            form.submit();
        },
        validate: async () => {
            try {
                const values = await form.validateFields(); // Validate form fields
                return { valid: true, values }; // Return valid status and values
            } catch (error) {
                return { valid: false, errors: error.errorFields }; // Return errors if validation fails
            }
        },
        values: () => {
            return form.getFieldsValue();
        }
    }));

    const handleClick = (vehicle) => {
        setSelectedVehicle(vehicle)
    }

    const onFinish = (values) => {
        console.log("Form Values:", values);
    };

    const sortPackagesByPrice = (packages) => {
        return [...packages].sort((a, b) => {
            return Number(a.priceInPKR) - Number(b.priceInPKR);
        });
    };

    return (
        <div className="vehicle-plans">
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={
                    {...initialValues}
                }
            >
                
                <div className='text-lg !text-white font-bold mt-4' style={{ color: 'black', backgroundColor: '#00803e' }}>
                    Select Tourism Package
                </div>
                <div>

                </div>
                <div className='grid lg:grid-cols-4 md:grid-cols-3 mx-auto !mt-6'>
                    {
                        sortPackagesByPrice(vehicles || [])?.map((vehicle) => {
                            return (
                                <Card
                                    className='!mx-auto mb-12 !mt-8 vehicle-card cursor-pointer'
                                    hoverable
                                    style={{
                                        width: 240,
                                        backgroundColor: '#E5E4E2',
                                        borderRadius: '8px',
                                        border: selectedVehicle?.id == vehicle?.id ? '5px solid #00803e' : ''
                                    }}
                                    cover={<img alt="example" className='h-[138px]' style={{
                                        objectFit: 'contain'
                                    }} src={`${config.API_URL}/${vehicle.pictureURL}`} />}
                                >
                                    <div className='text-lg font-bold' style={{ backgroundColor: '#00803e', color: 'white' }}>
                                        {vehicle.name}
                                    </div>
                                    <div className='text-base pt-1'>
                                        {vehicle.description}
                                    </div>
                                    <div className='text-base pt-1 font-semibold'>
                                        {currency} {convertCurrency(vehicle.priceInPKR)}
                                    </div>
                                    <Button onClick={() => {
                                        Modal.info({
                                            icon: null,
                                            maskClosable: true,
                                            okText: 'Close',
                                            content: (
                                                <div style={{display: 'flex', justifyContent: 'center'}}>
                                                    <img 
                                                        alt={vehicle.name}
                                                        src={`${config.API_URL}/${vehicle.pictureURL}`}
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '80vh',
                                                            objectFit: 'contain'
                                                        }}
                                                    />
                                                </div>
                                            ),
                                            width: '90vw',
                                            centered: true
                                        });
                                    }} type='button' className='w-full mt-2' style={{
                                        backgroundColor: '#ffffff', 
                                        color: '#00803e',
                                        border: '1px solid #00803e',
                                        marginBottom: '10px'
                                    }}>View Details</Button>
                                    <Button onClick={() => { handleClick(vehicle) }} type='button' className='w-full mt-2' style={{
                                        backgroundColor: '#00803e',
                                        color: '#ffffff'
                                    }}>Select</Button>
                                </Card>
                            )
                        })
                    }
                </div>
                {
                    loading &&
                    'Loading...'
                }
            </Form>
        </div>
    );
});

export default TourPackageSelectForm;
